

















import { Component, Vue } from 'vue-property-decorator'
import bus from '../../utils/eventBus'
@Component({
  name: 'Welcome'
})
export default class Welcome extends Vue {
  public flagForShowMenu = true

  showTheMenu () {
    bus.$emit('operationForShowTheMenu', true)
    this.flagForShowMenu = false
  }

  mounted () {
    const welcomeContainerInnerTitleContentDOM = document.querySelector('.welcome_container_inner_title_content')
    const timerIdForwelcomeContainerInnerTitleContentDOM = setInterval(() => {
      welcomeContainerInnerTitleContentDOM.classList.add('animate__swing')
      setTimeout(() => {
        welcomeContainerInnerTitleContentDOM.classList.remove('animate__swing')
      }, 500)
    }, 2000)
    this.$on('hook:beforeDestroy', () => {
      bus.$emit('operationForShowTheMenu', false)
      timerIdForwelcomeContainerInnerTitleContentDOM && clearInterval(timerIdForwelcomeContainerInnerTitleContentDOM)
    })
  }
}
